import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import _ from "lodash";
import actions from "@redux/facilityCategory/actions";
import {connect} from "react-redux";
import {api} from "@redux/api";
import {
    Facility_CategoryColumns,
    Facility_CategoryProps
} from "@containers/facility/Facility_Category/Facility_CategoryColumns";
import {
    Facility_CategoryFormFields,
    Facility_CategoryRelated
} from "@containers/facility/Facility_Category/Facility_CategoryFormFields";

class Facility_Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
        }
    }

    handleCreateFacilityCategory = (body) => {
        return api.createFacilityCategory(body).then(
            response => {
                console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteFacilityCategory = (id) => {
        return api.deleteFacilityCategory(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkFacilityCategoryInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteFacilityCategory(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        return api.editFacilityCategory(key, row).then(
            response => {
                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {
        console.log('triggered', query)
        this.setState({
            isLoading: true
        })
        return api.filterFacilityCategory(query).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                }
            }
        ).catch(error => (
            error
        ));
    }

    getFacilityCategory = (data) => {
        this.setState({
            data,
            isLoading: false,
        })
        this.props.setFacilityCategorySuccess(data)
    }

    render() {
        return (

            <div className="m-5">
                <EditableTable
                    columns={Facility_CategoryColumns}
                    data={this.state.data}
                    columnProps={Facility_CategoryProps}
                    formFields={Facility_CategoryFormFields}
                    formRelated={Facility_CategoryRelated}
                    getRecord={this.getFacilityCategory}
                    createRecords={this.handleCreateFacilityCategory}
                    deleteRecord={this.handleDeleteFacilityCategory}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    relatedList={this.props.relatedList}
                    hide_date={true}
                    hide_imports={true}
                    isRowClickable={true}
                    hide_search={true}
                    isChat={false}
                    isRelated={false}
                    isAttachments={false}
                />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Facility: _.get(state.Facility, 'data'),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFacilityCategorySuccess: (e) => dispatch(actions.FacilityCategorySuccess(e)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Facility_Category);

